export class PagingMetaModel {
    current_page: number = 1;
    from: any;
    last_page: any;
    path: any;
    per_page: number = 10;
    to: any;
    total: any;
}
